import VueFactory from '../../helpers/vueFactory';
import PartnerOfferView from '../../components/PartnerOffer/PartnerOfferView.vue';
import { factory as initMobileHeaderMenu } from '../../components/MobileHeaderMenu/MobileHeaderMenu.vue';
import initApplicationGlobal from '../Global/Global';

export default function initTrackingPage(eventHub) {
  initApplicationGlobal(eventHub);

  if (document.querySelector('#partner-offer')) {
    VueFactory(PartnerOfferView, {
      el: '#partner-offer',
      data: {
        eventHub,
      },
    });
  }

  initMobileHeaderMenu({
    subpage: true,
  });
}
